// タップ内でメディア要素の再生準備に使う、100msの無音PCM。
// 呼び出し元で不要になったらURL.revokeObjectURLで解放する。
export const createCountLessonSilentMediaURL = () => {
    const sampleRate = 44100;
    const sampleCount = sampleRate / 10;
    const dataSize = sampleCount * 2;
    const header = new ArrayBuffer(44);
    const view = new DataView(header);
    const writeText = (offset, text) => {
        for (let i = 0; i < text.length; i++)
            view.setUint8(offset + i, text.charCodeAt(i));
    };
    writeText(0, 'RIFF');
    view.setUint32(4, 36 + dataSize, true);
    writeText(8, 'WAVE');
    writeText(12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * 2, true);
    view.setUint16(32, 2, true);
    view.setUint16(34, 16, true);
    writeText(36, 'data');
    view.setUint32(40, dataSize, true);
    return URL.createObjectURL(new Blob([header, new Uint8Array(dataSize)], { type: 'audio/wav' }));
};
